var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndflag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.390625,
    y: 0.189453,
    width: 12.6205,
    height: 12.6205,
    fill: "url(#pattern0_2277_7983)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2277_7983",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2277_7983",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2277_7983",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEO0lEQVR4nO2Zy08TURTGZ6MuffwD6tbHkiihGheoC8S/wkRNjPja+Ni4I0ELK8XoympbyspH8IHSuNIoEilWQB0U0IgtGC1zF7r5zDkFlMSkG8sZpt8vOclkGJLh+829596L5xFCCCGEEEIIIYQQQgghhBBCyAK44tXhsreL5VU/gyteXcVPD51eHp0eWN5SZJCnkM5QfWwUAnsJFAL74CkE9mFTCOwDphDYh0ohsA+SQmAfHoXAPjAKgX1IFBKCYEAh9mEgBMWjE9hLoBDYB08hsA+bQmAfMIXAPlQKgX2QFIJaFfLr+fmun/2tT1itVc9Asq4oxDmXd86B5ZYig3zkhJRKAXy/oCXX1u9Tk0KCwCGReIXGxiRWrGjDunUdWitXtum9GzcG9Rnr96wJIb5fQH39dWzdeg2HD/dgaOgzRkamMDo6pdeHDvVgy5ZriMUSGBsrmr9vpIX4fgHr11/C/v3dGB+fxvT0D7x4MaHBf/hQRH//JL59K+nP9u3LYMOGS3rf+r0jKSQInI4MkfHmzRfMzgbo6RnFrVvDePlyEgMDk7h7dwT37r3VZ4eHp9Dc3K0jJcTT1/IVkki80mlqYmJGA06lcshmfaRSQ4jHn+Lixafo7s7rvXR6SIXJs5s3X8XNm4Pm7x85IY2NSe0ZMzM/dCTcv/8WZ89mcfJkL44ff4gTJ3r1Wu49fuzrM8Xid+0pe/akzN8/UkJKpQCrVl3Qpi194vbtYaTTORVw7lwWLS0PtM6cyeLUqV4dITKVybODg5/1d0O6JF6eQt6/L2Dt2g5dSUmTln7R3v4Mx4491PK8Vi25FjHys4GBT/qsrMDWrGnXBYH13xEZIb5f0FAl3LKQTxq6hH/06GIhUmUhk3NCvmL16nhYl8DLecpqQy5XnrJkOkomcws9Q3qIiDh9uk97iTR8mdb+TFltnLL+t5Tdu1P/bOoiQEqkSP+Qe319i5v63r1p848qUiPEOafHIbID/3vZ++jROx0psuyNx58hk3m9aNk7Pj6DTZuu6rPW7x85IUHgdJPX3JxZ2BjKKClvDCe0Z9y5Ux458xvDpqYu7NzJjWHVpIyNFfU4RI5F5HhEpi/pE/NHJ3KMIkcnHz9Oo6kpg40bL+u19ccUyRHi5kqC37EjoTtw6SnS6GU5LCUNXHqGTFMyMkIuIxpC3Nz0JcchsgOXI3fZo8iyWK7lXoh7RjSFuL9Kesn8P6jk2vp9al6Isw+1ukKOZFq6DiQPPmEdrHoGknVFIdvjDfnt8RhYsSXIoKHyCKGQ2BJ+jBSCcI18CoG9BAqBffAUAvuwKQT2AVMI7EOlENgHSSGwD49CYB8YhcA+JAoJQTAxCrEPIxaC4tEJ7CVQCOyDpxDYh00hsA+YQmAfKoWgpoTUd9TXbWtv2MVqqHoGknVFIYQQQgghhBBCCCGEEEIIIYQQr3b4DYcy3yzgaA4GAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndflag);
export default __webpack_public_path__ + "static/media/indflag.8f3749711975bd47caaf0b1df948c592.svg";
export { ForwardRef as ReactComponent };